import reprocessUnitsService from "../shared/services/reprocessUnitsService";

const REQUEST_REPROCESS_UNITS = "REQUEST_REPROCESS_UNITS";
const RESPONSE_REPROCESS_UNITS = "RESPONSE_REPROCESS_UNITS";
const REQUEST_REPROCESS_UNITS_FAILURE = "REQUEST_REPROCESS_UNITS_FAILURE";

const requestReprocessUnitsAction = () => {
  return {
    type: REQUEST_REPROCESS_UNITS,
  };
};

const responseReprocessUnitsAction = (data) => {
  return {
    type: RESPONSE_REPROCESS_UNITS,
    data,
  };
};

const requestReprocessUnitsFailureAction = (errors) => {
  return {
    type: REQUEST_REPROCESS_UNITS_FAILURE,
    errors,
  };
};

const getReprocessUnits = (options) => {
  return (dispatch) => {
    dispatch(requestReprocessUnitsAction());

    reprocessUnitsService
      .getReprocessUnits(options)
      .then((result) => {
        dispatch(responseReprocessUnitsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestReprocessUnitsFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_REPROCESS_UNIT = "REQUEST_CREATE_REPROCESS_UNIT";
const RESPONSE_CREATE_REPROCESS_UNIT = "RESPONSE_CREATE_REPROCESS_UNIT";
const REQUEST_CREATE_REPROCESS_UNIT_FAILURE = "REQUEST_CREATE_REPROCESS_UNIT_FAILURE";

const requestCreateReprocessUnitAction = () => {
  return {
    type: REQUEST_CREATE_REPROCESS_UNIT,
  };
};

const responseCreateReprocessUnitAction = (data) => {
  return {
    type: RESPONSE_CREATE_REPROCESS_UNIT,
    data,
  };
};

const requestCreateReprocessUnitFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_REPROCESS_UNIT_FAILURE,
    errors,
  };
};

const createReprocessUnit = (options) => {
  return (dispatch) => {
    dispatch(requestCreateReprocessUnitAction());

    reprocessUnitsService
      .createReprocessUnit(options)
      .then((result) => {
        dispatch(responseCreateReprocessUnitAction(result.data));
      })
      .catch((error) => {
        dispatch(requestCreateReprocessUnitFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_REPROCESS_UNIT = "REQUEST_DELETE_REPROCESS_UNIT";
const RESPONSE_DELETE_REPROCESS_UNIT = "RESPONSE_DELETE_REPROCESS_UNIT";
const REQUEST_DELETE_REPROCESS_UNIT_FAILURE = "REQUEST_DELETE_REPROCESS_UNIT_FAILURE";

const requestDeleteReprocessUnitAction = () => {
  return {
    type: REQUEST_DELETE_REPROCESS_UNIT,
  };
};

const responseDeleteReprocessUnitAction = (data) => {
  return {
    type: RESPONSE_DELETE_REPROCESS_UNIT,
    data,
  };
};

const requestDeleteReprocessUnitFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_REPROCESS_UNIT_FAILURE,
    errors,
  };
};

const deleteReprocessUnit = (options) => {
  return (dispatch) => {
    dispatch(requestDeleteReprocessUnitAction());

    reprocessUnitsService
      .deleteReprocessUnit(options.id)
      .then((result) => {
        dispatch(responseDeleteReprocessUnitAction(options));
      })
      .catch((error) => {
        dispatch(requestDeleteReprocessUnitFailureAction(error.response));
      });
  };
};

const REQUEST_REPROCESS_TYPES = "REQUEST_REPROCESS_TYPES";
const RESPONSE_REPROCESS_TYPES = "RESPONSE_REPROCESS_TYPES";
const REQUEST_REPROCESS_TYPES_FAILURE = "REQUEST_REPROCESS_TYPES_FAILURE";

const requestReprocessTypesAction = () => {
  return {
    type: REQUEST_REPROCESS_TYPES,
  };
};

const responseReprocessTypesAction = (data) => {
  return {
    type: RESPONSE_REPROCESS_TYPES,
    data,
  };
};

const requestReprocessTypesFailureAction = (errors) => {
  return {
    type: REQUEST_REPROCESS_TYPES_FAILURE,
    errors,
  };
};

const getReprocessTypes = () => {
  return (dispatch) => {
    dispatch(requestReprocessTypesAction());

    reprocessUnitsService
      .getReprocessUnitsTypes()
      .then((result) => {
        dispatch(responseReprocessTypesAction(result.data));
      })
      .catch((error) => {
        dispatch(requestReprocessTypesFailureAction(error.response));
      });
  };
};

export {
  REQUEST_REPROCESS_UNITS,
  RESPONSE_REPROCESS_UNITS,
  REQUEST_REPROCESS_UNITS_FAILURE,
  getReprocessUnits,
  REQUEST_CREATE_REPROCESS_UNIT,
  RESPONSE_CREATE_REPROCESS_UNIT,
  REQUEST_CREATE_REPROCESS_UNIT_FAILURE,
  createReprocessUnit,
  REQUEST_DELETE_REPROCESS_UNIT,
  RESPONSE_DELETE_REPROCESS_UNIT,
  REQUEST_DELETE_REPROCESS_UNIT_FAILURE,
  deleteReprocessUnit,
  REQUEST_REPROCESS_TYPES,
  RESPONSE_REPROCESS_TYPES,
  REQUEST_REPROCESS_TYPES_FAILURE,
  getReprocessTypes,
};
